import { DraftSatoSetResponse, OnboardingStatus, TrayOnboardingStatus } from 'api/Responses/SatoResponses';
import { VideoType } from 'api/Responses/TrayResponses';
import produce from 'immer';

export type SelectedSetContextState = {
  selectedSet: DraftSatoSetResponse | null;
  selectedTrayIndex: number | null;
  selectedVideoIndex: number | null;
};

export type SelectedSetAction =
  | {
      type: 'SET_SELECTED_SET';
      payload: SelectedSetContextState['selectedSet'];
    }
  | {
      type: 'SET_SELECTED_TRAY';
      payload: SelectedSetContextState['selectedTrayIndex'];
    }
  | {
      type: 'SET_SELECTED_VIDEO';
      payload: SelectedSetContextState['selectedVideoIndex'];
    }
  | {
      type: 'REVIEW_SET';
      payload: {
        status: OnboardingStatus;
      };
    }
  | {
      type: 'REVIEW_TRAY';
      payload: {
        status: TrayOnboardingStatus;
        comment?: string;
      };
    }
  | {
      type: 'REVIEW_VIDEO';
      payload: {
        status: OnboardingStatus;
        crop_start?: number;
        crop_end?: number;
      };
    }
  | {
      type: 'DELETE_VIDEO';
      payload: {
        type: VideoType;
        order: number;
      };
    }
  | {
      type: 'CLEAR';
    };

const selectedSetReducer = produce((state: SelectedSetContextState, action: SelectedSetAction) => {
  const trayIndex = state.selectedTrayIndex;
  const videoIndex = state.selectedVideoIndex;

  switch (action.type) {
    case 'SET_SELECTED_SET':
      state.selectedSet = action.payload;
      break;

    case 'SET_SELECTED_TRAY':
      state.selectedTrayIndex = action.payload;
      break;

    case 'SET_SELECTED_VIDEO':
      state.selectedVideoIndex = action.payload;
      break;

    case 'REVIEW_SET':
      if (state.selectedSet) {
        state.selectedSet.status = action.payload.status;
      }
      break;

    case 'REVIEW_TRAY':
      if (state.selectedSet && trayIndex !== null) {
        state.selectedSet.trays[trayIndex].status = action.payload.status;

        if (action.payload.comment) state.selectedSet.trays[trayIndex].comments.push(action.payload.comment);
      }
      break;

    case 'REVIEW_VIDEO':
      if (state.selectedSet && trayIndex !== null && videoIndex !== null) {
        state.selectedSet.trays[trayIndex].videos[videoIndex].status = action.payload.status;
        state.selectedSet.trays[trayIndex].videos[videoIndex].crop_start = action.payload.crop_start;
        state.selectedSet.trays[trayIndex].videos[videoIndex].crop_end = action.payload.crop_end;
      }
      break;

    case 'DELETE_VIDEO':
      if (state.selectedSet && trayIndex !== null) {
        const existingVideoIndex = state.selectedSet.trays[trayIndex].videos.findIndex(
          video => video.type === action.payload.type && video.order === action.payload.order,
        );

        if (existingVideoIndex >= 0) {
          delete state.selectedSet.trays[trayIndex].videos[existingVideoIndex];
        }
      }
      break;

    case 'CLEAR':
      state.selectedSet = null;
      break;
  }
});

export default selectedSetReducer;
